import { render, staticRenderFns } from "./AssetsHistogram.vue?vue&type=template&id=ab9cfe0e&"
import script from "./AssetsHistogram.vue?vue&type=script&lang=js&"
export * from "./AssetsHistogram.vue?vue&type=script&lang=js&"
import style0 from "./AssetsHistogram.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports